<script lang="ts">
  import { store } from '../lib/store.svelte.ts';
  import { router } from '../lib/router.svelte.ts';
  import { daysShort } from '../lib/format.ts';
  import NewCartsSheet from '../lib/NewCartsSheet.svelte';

  let q = $state('');
  let siteFilter = $state('');
  let statusFilter = $state<'all' | 'active' | 'written_off'>('active');
  let creating = $state(false);

  const rows = $derived.by(() => {
    const needle = q.trim().toLowerCase();
    return [...store.states.values()]
      .filter((s) => {
        if (statusFilter === 'active' && s.status !== 'active') return false;
        if (statusFilter === 'written_off' && s.status === 'active') return false;
        if (siteFilter === '__none__' && s.current_site) return false;
        if (siteFilter && siteFilter !== '__none__' && s.current_site !== siteFilter) return false;
        if (needle && !s.code.toLowerCase().includes(needle) && !s.name.toLowerCase().includes(needle))
          return false;
        return true;
      })
      .sort((a, b) => a.code.localeCompare(b.code));
  });

</script>

<div class="row" style="margin-bottom:.5rem">
  <h1 class="grow">Chariots</h1>
  {#if store.isAdmin}
    <button class="primary slim" onclick={() => (creating = true)}>Ajouter</button>
  {/if}
</div>

<div class="card">
  <div class="toolbar">
    <input placeholder="Rechercher un nom ou un code…" bind:value={q} aria-label="Rechercher" />
    <select bind:value={siteFilter} aria-label="Filtrer par site">
      <option value="">Tous les sites</option>
      <option value="__none__">Sans site</option>
      {#each store.sites as s (s.code)}<option value={s.code}>{s.name}</option>{/each}
    </select>
    <select bind:value={statusFilter} aria-label="Filtrer par statut">
      <option value="active">En service</option>
      <option value="written_off">Retirés / perdus</option>
      <option value="all">Tous</option>
    </select>
  </div>
  <div class="row wrap tiny muted" style="margin-top:.5rem">
    <span class="grow">{rows.length} chariot(s)</span>
    <a href="/api/export/carts.csv">Export CSV</a>
    <a href="#/labels">Étiquettes</a>
  </div>
</div>

{#if rows.length === 0}
  <div class="card"><p class="empty">Aucun chariot ne correspond.</p></div>
{:else}
  <ul class="list card">
    {#each rows as s (s.code)}
      <li>
        <button class="row-link" onclick={() => router.go(`carts/${s.code}`)}>
          <span class="stack" style="gap:.1rem;align-items:flex-start">
            <span class="truncate row-title">{s.name}</span>
            <span class="mono tiny muted">{s.code}</span>
          </span>
        </button>
        <span class="stack right" style="gap:.2rem;align-items:flex-end">
          {#if s.current_site}
            <span class="tiny muted truncate">{store.siteName(s.current_site)}</span>
            <span class="tiny subtle">{daysShort(s.days_present)}</span>
          {:else}
            <span class="tiny subtle">jamais vu</span>
          {/if}
        </span>
        {#if s.missing_since}<span class="pill danger">manquant</span>
        {:else if s.stale}<span class="pill warn">ancien</span>{/if}
        {#if s.status !== 'active'}
          <span class="pill">{s.status === 'lost' ? 'perdu' : 'retiré'}</span>
        {/if}
      </li>
    {/each}
  </ul>
{/if}

{#if creating}
  <NewCartsSheet onclose={() => (creating = false)} />
{/if}
